import moment from 'moment';
import { setTimezoneWithoutAlteringTime } from 'utils/utility_functions/timezone';

/**
 * Get page limit from user preferences based on context
 * @param {boolean} isLeadSpecific - Whether this is from lead-specific module
 * @param {boolean} isFromCaseSpecificModule - Whether this is from case-specific module
 * @param {Object} userContext - User context object
 * @returns {number|undefined} Page limit or undefined
 */
export const getPageLimit = (isLeadSpecific, isFromCaseSpecificModule, userContext) => {
  if (isLeadSpecific && userContext) {
    return userContext?.firmDetails?.pagination_preference?.leads?.billings?.payments_request;
  } else if (isFromCaseSpecificModule && userContext) {
    return userContext?.firmDetails?.pagination_preference?.case?.billings?.payments_request;
  } else if (userContext) {
    return userContext?.firmDetails?.pagination_preference?.billings?.payments_request;
  }
  return undefined;
};

/**
 * Get file path for pagination preferences
 * @param {boolean} isLeadSpecific - Whether this is from lead-specific module
 * @param {boolean} isFromCaseSpecificModule - Whether this is from case-specific module
 * @param {Object} userContext - User context object
 * @returns {Object} Path object with module, subModule, and listName
 */
export const getFilePathForPagination = (isLeadSpecific, isFromCaseSpecificModule, userContext) => {
  if (isLeadSpecific && userContext) {
    return { module: 'leads', subModule: 'billings', listName: 'payments_request' };
  } else if (isFromCaseSpecificModule && userContext) {
    return { module: 'case', subModule: 'billings', listName: 'payments_request' };
  } else {
    return { module: 'billings', subModule: '', listName: 'payments_request' };
  }
};

/**
 * Extract date range from calendar selection and convert to timezone format
 * @param {Array} dateArray - Array of dates from calendar [startDate, endDate]
 * @param {string} timezone - User's timezone
 * @returns {Object} Object with payment_date_lower and payment_date_upper
 */
export const pickExtractedDate = (dateArray, timezone) => {
  return {
    payment_date_lower: dateArray?.[0] ? setTimezoneWithoutAlteringTime(moment(dateArray[0]).startOf('day'), timezone) : '',
    payment_date_upper: dateArray?.[0]
      ? setTimezoneWithoutAlteringTime(moment(dateArray[1] ? dateArray[1] : dateArray[0]).endOf('day'), timezone)
      : '',
  };
};
